export function findModel (vnode) {
  if (!vnode.data) {
    return null
  }

  // Component Model
  if (vnode.data.model) {
    return vnode.data.model
  }

  // return (!!vnode.data.directives && find(vnode.data.directives, d => d.name === "model")
  return vnode.data.directives.find(d => d.name === 'model')
}

export function validatorFound (vnode) {
  let modelName = findModel(vnode).expression
  let validator = vnode.context.$validator

  let foundObjects = validator.filter(v => v.vmod === modelName)

  return foundObjects.length > 0
}
